import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'

import RenderInput from './RenderInput'
import Captcha from './Captcha'

import Validator from '../validator'
import Submit from '../submit'

class RegisterForm extends Component {
  render() {
    const { required, validString, passwordLength, samePassword, lengthMax16, email } = Validator
    const { valid, handleSubmit, submitting } = this.props

    const canSubmit = valid && !submitting

    return (
      <div className="center-block">
        <div className="panel panel-default" style={{ margin: 'auto', width: '30%' }}>
          <div className="panel-body">
            <h1 className="text-center">Register</h1>
            <hr/>
            <form onSubmit={canSubmit ? handleSubmit(Submit) : (e) => e.preventDefault()}>
              <Field
                className="form-control"
                name="user"
                component={RenderInput}
                type="text"
                label="Username"
                help="This is the name that others will see."
                validate={[required, lengthMax16, validString]} />
              <Field
                className="form-control"
                name="minecraft"
                component={RenderInput}
                type="text"
                label="Minecraft Name"
                help="Your Minecraft name."
                validate={[required, lengthMax16, validString]} />
              <Field
                className="form-control"
                name="mail"
                component={RenderInput}
                type="email"
                label="Email"
                help="This email will be used to confirm registration and for password resets."
                validate={[required, email]} />
              <Field
                className="form-control"
                name="pw"
                component={RenderInput}
                type="password"
                label="Password"
                help="Password must be 8 or more characters long."
                validate={[required, passwordLength]} />
              <Field
                className="form-control"
                name="pw_re"
                component={RenderInput}
                type="password"
                label="Re-Enter Password"
                help="Please re-enter your password."
                validate={[required, samePassword]} />
              <Field
                name="g-recaptcha-response"
                component={Captcha}
                validate={[required]} />
              <hr/>
              <button type="submit" className="btn btn-primary btn-block" disabled={!canSubmit}>Submit</button>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

// Decorate the form component
RegisterForm = reduxForm({
  form: 'register'
})(RegisterForm)

export default RegisterForm;


// WEBPACK FOOTER //
// ./src/components/RegisterForm.js